import { keyBy, mapValues } from "lodash-es";
import { i18nService } from "services";
import { IToolFacet, IFieldType, IFormSchema, ToolFacetType } from "types";
import { capitalize } from "lodash";

export const makeSchema = (facets: IToolFacet[]): IFormSchema => {
  const facetsWithoutType = facets.filter(
    (facet) => facet.key !== ToolFacetType.type
  );

  return {
    layout: "inline",
    submitMode: "onDirty",
    fields: [
      {
        name: "lookingFor", // used as key
        type: IFieldType.staticText,
        label: i18nService.copy["toolQuickSearch.lookingFor"],
      },
      ...facetsWithoutType.map(({ key, slug, label, options, ...rest }) => ({
        ...rest,
        name: slug,
        type: IFieldType.select,
        label: capitalize(label.split(" ")[label.split(" ").length - 1]),
        hideLabel: true,
        options: [
          {
            label: i18nService.copy["toolQuickSearch.choose"]?.replace(
              "@filter",
              label.toLowerCase()
            ),
            value: "", // placeholder value
          },
          ...options.map((option) => ({
            label: option.label,
            value: option.id,
          })),
        ],
      })),
    ],
    defaultValues: mapValues(keyBy(facetsWithoutType, "slug"), ""), // set to placeholder value
    resetDefaultValues: false,
  };
};
